import { useEffect, useMemo } from 'react'
import { useParams } from 'react-router-dom'

import { ThemeProvider } from '@mui/material'
import { fontTheme } from '../styles/font'

import GroupSpecific from '../components/group/GroupSpecific'

import { fetchFeedPlanData } from '../store/feedPlanSlice'
import { useAppDispatch, useAppSelector } from '../store/hooks'

import PageContainer from 'layouts/PageContainer'
import { fetchGroupData } from 'store/groupsSlice'
import Preloader from 'ui/Preloader'

const theme = fontTheme
const GroupPage = () => {
	const urlParams = useParams()
	const dispatch = useAppDispatch()
	const { currentGroup, loading } = useAppSelector(state => state.groupsReducer)
	const feedPlanDate = useMemo(() => new Date(), [])

	useEffect(() => {
		dispatch(fetchFeedPlanData({ date: feedPlanDate }))
	}, [dispatch, feedPlanDate])

	useEffect(() => {
		dispatch(fetchGroupData(urlParams.groupkey))
	}, [dispatch, urlParams.groupkey])

	useEffect(() => {
		if (!urlParams.groupkey) return
		const intervalId = setInterval(() => {
			dispatch(fetchGroupData(urlParams.groupkey))
		}, 15000)

		return () => clearInterval(intervalId)
	}, [dispatch, urlParams.groupkey])

	return (
		<ThemeProvider theme={theme}>
			<PageContainer>
				{!loading && currentGroup ? (
					<GroupSpecific {...currentGroup} />
				) : (
					<Preloader />
				)}
			</PageContainer>
		</ThemeProvider>
	)
}

export default GroupPage
